import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import SideNavigation from "@cloudscape-design/components/side-navigation";
import { useAuth } from "../../context/AuthContext";
import { useMenu } from "../../context/MenuContext";
import ChatHistorySidebar from "./ChatHistorySidebar";

export default function AppSidebar() {
  const { companylogo, isAdmin } = useAuth();
  const { isMenuVisible } = useMenu();
  const history      = useHistory();
  const { pathname } = useLocation();

  const canSee  = (path) => isAdmin() || isMenuVisible(path);
  const isChatbot = pathname === "/boxer/execute-query";

  const buildNavItems = () => {
    const items = [];

    // items.push({ type: "link", text: "Home", href: "/"});

    const conversationItems = [];
    if (canSee("/boxer/execute-query")) {
      conversationItems.push({ type: "link", text: "Chatbot", href: "/boxer/execute-query" });
    }
    if (conversationItems.length > 0) {
      items.push({ type: "section", text: "ConversationsIQ", items: conversationItems, defaultExpanded: pathname === "/boxer/execute-query"});
    }

    const insightItems = [];
    if (canSee("/boxer/delivery-command-center")) {
      insightItems.push({ type: "link", text: "Command Center", href: "/boxer/delivery-command-center" });
    }
    if (canSee("/boxer/delivery-monitoring")) {
      insightItems.push({ type: "link", text: "Delivery Monitoring", href: "/boxer/delivery-monitoring" });
    }
    if (insightItems.length > 0) {
      items.push({ type: "section", text: "InsightIQ", items: insightItems, defaultExpanded: pathname === "/boxer/delivery-command-center" || pathname === "/boxer/delivery-monitoring" });
    }

    if (isAdmin()) {
      items.push({ type: "divider" });
      items.push({ type: "link", text: "Admin Portal", href: "/admin" });
    }

    return items;
  };

  return (
    <div style={{
      display:       "flex",
      flexDirection: "column",
      height:        "100%",
      overflow:      "hidden",
    }}>
      {/* Logo */}
      <div
        style={{ padding: "14px 16px 10px", borderBottom: "1px solid #e3e8ef", cursor: "pointer", flexShrink: 0 }}
        onClick={() => history.push("/")}
      >
        <img
          src={companylogo}
          alt="logo"
          style={{ height: 38, maxWidth: "100%", objectFit: "contain", display: "block" }}
        />
      </div>

      {/* Navigation links */}
      <div style={{ flexShrink: 0 }}>
        <SideNavigation
          activeHref={pathname}
          items={buildNavItems()}
          onFollow={(e) => {
            e.preventDefault();
            history.push(e.detail.href);
          }}
        />
      </div>

      {/* Chat history — only on chatbot page, fills remaining space */}
      {isChatbot && (
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", borderTop: "1px solid #e3e8ef" }}>
          <ChatHistorySidebar />
        </div>
      )}
    </div>
  );
}
